module.exports = __webpack_public_path__ + "static/img/product-swipe32.fe68c4eb.png";